<template>
  <div>
    <div class="nav_pos">
      <span class="text">当前位置：</span>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item v-for="(item, index) in breadUrl" :key="index">
          <router-link v-if="item.url" :to="item.url">{{ item.name }}</router-link>
          <a v-else>{{ item.name }}</a>
        </el-breadcrumb-item>
        <div class="searchWrap">
          <el-input class="searchInput" v-model="searchInput" placeholder="请输入搜索内容" @keyup.enter.native="searchDetail()">
            <i class="el-icon-search elIconSearch_cus1" slot="suffix" @click.stop="searchDetail()"></i>
          </el-input>
        </div>
      </el-breadcrumb>
    </div>
    <div class="top_line">
      <LeftTab :info="info" @switchCon="switchPage"></LeftTab>
      <div class="right_wrap">
        <ul class="li_wrap list_minHeight line_li_wrap">
          <li class="clear" v-for="(item, index) in biddlist1" :key="index" @click.stop="goDetail(item.id)">
            <span class="li_left overell">{{ item.title }}</span>
            <span class="li_right">{{ item.date }}</span>
          </li>
        </ul>
        <el-pagination class="page_wrap" background :page-size="pageSize" layout="prev, pager, next" :total="quesLength" @current-change="handleCurrentChange"></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import LeftTab from '@/components/common/LeftTab'

export default {
  name: 'news',
  components: { LeftTab },
  data() {
    return {
      breadUrl: {},
      searchInput: '',
      info: {
        //左边tab的数据
        imgUrl: require('../../assets/img/icon_law.png'),
        text: '政策法规',
        egText: 'Regulation',
        tabList: []
      },
      quesLength: 100,
      biddlist1: [],
      pageSize: 11,
      quesLength: 0,
      pageIndex: 1,
      biddlist1: [],
      supplier: null,
      cateId: ''
    }
  },
  mounted() {
    sessionStorage.setItem('IndexTab', 'policyregular')
    this.getRequest('/Information/Index')
      .then((res) => {
        var data = res.data
        if (data.errcode == 0) {
          this.cateId = data.policy.Id
          this.policy = data.policy
          this.getCates()
          this.getList(this.cateId)
        }
      })
      .catch(function (error) {
        console.log(error)
      })
  },
  methods: {
    getCates() {
      let config = {
        params: {
          cateId: this.cateId
        }
      }
      this.getRequest('/Information/GetCates', config)
        .then((res) => {
          var data = res.data
          if (data.errcode == 0) {
            this.info.tabList = data.cateList
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    getList(cateId) {
      let config = {
        params: {
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          cateId: cateId,
          title: this.searchInput
        }
      }
      this.getRequest('/Information/GetList', config)
        .then((res) => {
          var data = res.data
          if (data.errcode == 0) {
            this.quesLength = data.quesLength
            this.biddlist1 = data.infoList
            this.breadUrl = data.nav
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    handleCurrentChange(val) {
      this.pageIndex = val
      this.getList(this.cateId)
    },
    switchPage(id) {
      console.log(id)
      this.pageIndex = 1
      this.cateId = id
      this.searchInput = ''
      console.log(this.pageIndex)
      this.getList(id)
    },
    goDetail(id) {
      let routerData = this.$router.resolve({
        name: 'detail',
        query: { id: id, cateId: this.cateId, purchaseType: 0 }
      })
      window.open(routerData.href, '_blank')
    },
    searchDetail() {
      this.pageIndex = 1
      this.getList(this.cateId)
    }
  }
}
</script>
<style scoped lang="scss">
.nav_pos .el-breadcrumb {
  position: relative;
  display: block;
}
.searchWrap {
  display: flex;
  position: absolute;
  right: 0;
  top: -7px;
  span {
    font-weight: bold;
  }
  ::v-deep.el-input__suffix {
    top: 3px;
  }
}
</style>
